import { useMutation, useQuery } from "@tanstack/react-query";
import { Module } from "../../../assets/types/common";
import { Constants } from "../../../assets/utils/lib/constants";
import { SearchDto } from "../../../assets/utils/lib/searchDto";
import { IActionResponse, IActionResult, LookupTypeClient } from "../../../services/proxies";
import { ViewProps } from "../props";

export class LookupTypeService<T extends ViewProps.CategoryTypeDto> {
    private lookupTypeClient: LookupTypeClient<T>;
    public constructor(moduleType: Module) {
        this.lookupTypeClient = new LookupTypeClient<T>(moduleType);
    }

    save = () =>
        useMutation<IActionResult<T>, Error, T>({
            mutationFn: async (payload: T) => {
                return await this.lookupTypeClient.saveLookupTypeAsync(payload);
            },
        });

    getLookupTypeQuery = (id: string | undefined) =>
        useQuery({
            queryKey: [ViewProps.LookupTypeQueryKeys[ViewProps.LookupTypeQueryTypes.Get], id],
            queryFn: async () => {
                return await this.lookupTypeClient.getLookupTypeAsync(id)
            },
            enabled: Boolean(id) && id !== Constants.emptyGuid,
        });

    getLookupTypesQuery = (typeId: string | undefined) =>
        useQuery({
            queryKey: [ViewProps.LookupTypeQueryKeys[ViewProps.LookupTypeQueryTypes.GetALLByType], typeId],
            queryFn:
                async () => await this.lookupTypeClient.getLookupTypesAsync(typeId),
            enabled: Boolean(typeId),
        });

    getAllLookupTypesQuery = () =>
        useQuery({
            queryKey: [ViewProps.LookupTypeQueryKeys[ViewProps.LookupTypeQueryTypes.GetAll]],
            queryFn: async () => {
                return await this.lookupTypeClient.getAllLookupTypesAsync()
            }
        });

    gridQuery = (searchQuery: SearchDto) =>
        useQuery({
            queryKey: [ViewProps.LookupTypeQueryKeys[ViewProps.LookupTypeQueryTypes.Grid], searchQuery],
            queryFn: async () =>
                await this.lookupTypeClient.searchLookupTypesAsync(searchQuery),
        });

    deActivate = () =>
        useMutation<IActionResponse, Error, string>({
            mutationFn: async (id: string | undefined) => {
                return await this.lookupTypeClient.deleteLookupTypeAsync(id);
            },
        });
}